import { IFetchPageQuery } from '../../IFetchQueryOptions';
import { IProgram } from '../../program/interface';
import { IUser } from '../../user/interface';

export enum NominationReadinessTrackStatus {
    READY_FOR_CUSTOMER_REVIEW = 'ready_for_customer_review',

    SCHEDULED = 'scheduled',

    SKIPPED = 'skipped',
    SENT = 'sent',

    REJECTED = 'rejected',
    CONFIRMED = 'confirmed',
}

export interface INominationReadinessTrack {
    id: string;
    userId: number;
    user: IUser | null;
    nominationIds: string[];
    programs: IProgram[];
    dateToSendEmail: string;
    dateEmailOpened: string | null;
    dateEmailSent: string | null;
    dateConfirmed: string | null;
    dateRejected: string | null;
    comment: string | null;
    accountManager: string | null;
    dateModified: string;
    dateCreated: string;

    status: NominationReadinessTrackStatus | null;
}

export interface ICreateNominationReadinessTrack {
    dateToSend: string;
    nominationIds: string[];
    timezone?: string;
}

export interface IFetchNominationReadinessTrackPageQuery extends IFetchPageQuery {}
